import React from "react";
import type {Path} from "wouter";

export type WithRouter = {
    navigate: (to: Path, options?: { replace?: boolean }) => void
    location: string,
}

export const withRouter = (Component: React.ComponentClass) => {
    const WrappedComponent = (props: any) => {
        // Implementation here
        return <Component {...props} />;
    };
    
    WrappedComponent.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;
    
    return WrappedComponent;
};
